module.exports = __webpack_public_path__ + "static/media/frontline-9-wireframe.bd2ffe3d.png";